import React from 'react';
import './GoBackArrow.css';

const GoBackArrow = ({ onBack, label = 'Volver', className = '' }) => {
    const handleClick = (e) => {
        if (e?.stopPropagation) {
            e.stopPropagation();
        }

        if (onBack && typeof onBack === 'function') {
            try {
                onBack();
            } catch (err) {
                console.error('GoBackArrow: error calling onBack prop', err);
            }
            return;
        }

        try {
            window.history.go(-1);
        } catch (err) {
            console.error('GoBackArrow: error calling history.go', err);
        }
    };

    return (
        <button
            type="button"
            className={`goback-btn allow-pointer-cursor ${className}`.trim()}
            onClick={handleClick}
            title={label}
            aria-label={label}
        >
            <i className="fa fa-arrow-left goback-btn__icon" aria-hidden="true" />
            <span className="goback-btn__label">{label}</span>
        </button>
    );
};

export default GoBackArrow;
